import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './anchor.styl'

export default class Anchor extends Component {
  static propTypes = {
    children: PropTypes.any,
    underline: PropTypes.bool,
    center: PropTypes.bool,
    block: PropTypes.bool,
    colorClass: PropTypes.string,
    margin: PropTypes.string,
  }

  static defaultProps = {
    block: false,
    center: false,
    underline: false,
    margin: '0',
  }

  render() {
    const {
      colorClass,
      underline,
      center,
      margin,
      block,
    } = this.props

    const classNames = [styles.anchor]

    block && classNames.push(styles.block)
    center && classNames.push(styles.center)
    underline && classNames.push(styles.underline)
    colorClass && classNames.push(styles[colorClass])

    return (
      <span className={classNames.join(' ')} style={{ margin }}>
        {this.props.children}
      </span>
    )
  }
}
